exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select-product-label-component-container[data-v-25fac516] {\n  width: 30%;\n  display: unset;\n  margin-left: 12px;\n}\n.select-product-label-component[data-v-25fac516] {\n  min-width: 250px;\n}\n", ""]);

// exports
